<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de órdenes de trabajo</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" class="btn-info btn--bigger" type="button">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="exportarExcel" class="btn-success btn--bigger" type="button">
            <i class="fa fa-file-excel-o"></i>
            <span>Excel</span>
          </button>
          <button @click="exportarPDF" class="btn-danger btn--bigger" type="button">
            <i class="fa fa-file-pdf-o"></i>
            <span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-2">
            <p>
              <label for="sinPersonas">
                <input
                  v-model="form.sin_personas"
                  type="checkbox"
                  name="sinPersonas"
                  id="sinPersonas"
                />
                <span>Sin personas</span>
              </label>
            </p>
          </div>
          <div v-show="!form.sin_personas" class="col-xs-12 col-md-5">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputPersona"
                  placeholder="Seleccione..."
                  id="persona"
                  v-model="selectedPersona"
                  :options="personas"
                  label="nombre"
                ></v-select>
                <label for="persona">Persona</label>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-md-5">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputVendedor"
                  placeholder="Seleccione..."
                  id="vendedor"
                  v-model="selectedVendedor"
                  :options="vendedores"
                  label="nombre"
                ></v-select>
                <label for="vendedor">Vendedor</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 mt-2">
            <div class="form-inline">
              <label>
                <strong>Filtros por estado</strong>
              </label>
              <label for="abiertas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="abiertas"
                  value="A"
                />
                <span>Abiertas</span>
              </label>
              <label for="asignadas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="asignadas"
                  value="V"
                />
                <span>Asignadas</span>
              </label>
              <label for="facturables">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="facturables"
                  value="B"
                />
                <span>Facturables</span>
              </label>
              <label for="facturadas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="facturadas"
                  value="F"
                />
                <span>Facturadas</span>
              </label>
              <label for="cerradas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="cerradas"
                  value="C"
                />
                <span>Cerradas</span>
              </label>
              <label for="anuladas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="anuladas"
                  value="E"
                />
                <span>Anuladas</span>
              </label>
              <label for="todas">
                <input
                  @change="consultar"
                  type="radio"
                  v-model="form.estado"
                  name="estado"
                  id="todas"
                  value="T"
                />
                <span>Todas</span>
              </label>
            </div>
          </div>
          <div class="col-xs-12 mt-2">
            <div class="form-inline">
              <label>
                <strong>Filtros por fecha</strong>
              </label>
              <label for="hoy">
                <input
                  @change="consultar"
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="hoy"
                  value="H"
                />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input
                  @change="consultar"
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="ayer"
                  value="A"
                />
                <span>Ayer</span>
              </label>
              <label for="rango">
                <input
                  @change="changePersonalizado"
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="rango"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipo_fecha === 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker
                    id="desde"
                    v-model="form.desde"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label>Desde</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipo_fecha === 'P'">
                <div
                  class="datepicker-field datepicker-field--stretch"
                  v-show="form.tipo_fecha === 'P'"
                >
                  <VueCtkDateTimePicker
                    id="hasta"
                    v-model="form.hasta"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label>Hasta</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 mt-2">
            <div class="form-inline">
              <label>
                <strong>Filtros de comprobante</strong>
              </label>
              <label for="conProforma">
                <input
                  @change="consultar"
                  type="radio"
                  name="conProforma"
                  id="conProforma"
                  v-model="form.con_proforma"
                  value="C"
                />
                <span>Con proforma</span>
              </label>
              <label for="sinProforma">
                <input
                  @change="consultar"
                  type="radio"
                  name="conProforma"
                  id="sinProforma"
                  v-model="form.con_proforma"
                  value="S"
                />
                <span>Sin proforma</span>
              </label>
              <label for="ambos">
                <input
                  @change="consultar"
                  type="radio"
                  name="conProforma"
                  id="ambos"
                  v-model="form.con_proforma"
                  value="A"
                />
                <span>Ambos</span>
              </label>
              <div class="form-field">
                <input-field
                  id="numeroProforma"
                  v-model="form.numero_proforma"
                  placeholder="Digite un número..."
                >
                  <span>Número de proforma</span>
                </input-field>
              </div>
              <div class="form-field">
                <input-field
                  id="numero_orden_trabajo"
                  v-model="form.numero_orden_trabajo"
                  placeholder="Digite un número..."
                >
                  <span>Número de orden de trabajo</span>
                </input-field>
              </div>
              <div class="form-field">
                <label for="conDetalle">
                  <input
                    v-model="form.conDetalle"
                    type="checkbox"
                    name="conDetalle"
                    id="conDetalle"
                  />
                  <span>Con detalles</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="table-responsive">
          <vue-good-table
            :row-style-class="rowStyleClassFn"
            :columns="[
                        {
                            label : 'Fecha de emisión',
                            field : 'fecha_emision',
                            filterable : true,
                        },
                        {
                            label : 'Persona',
                            field : 'nombre_persona',
                            filterable : true,
                        },
                        {
                            label : 'Número de proforma',
                            field : 'numero_proforma',
                            filterable : true,
                        },
                        {
                            label : 'Número de documento',
                            field : 'numero_documento',
                            filterable : true
                        },
                        {
                            label : 'Asignado',
                            field : 'nombre_vendedor',
                            filterable : true
                        },
                        {
                           label : 'Detalles',
                            field : 'detalles',
                            filterable : false,
                            hidden : !form.conDetalle
                        },
                        {
                            label : 'Costo total',
                            field : 'costo_total',
                            filterable : true
                        },
                        {
                            label : 'Estado',
                            field : 'descripcion_estado',
                            filterable : true
                        },
                        {
                            label : 'Observación',
                            field : 'observacion',
                            filterable : true
                        }
                    ]"
            :pagination-options="{
                            enabled: true,
                            perPage: 10,
                            nextLabel: 'siguiente',
                            prevLabel: 'anterior',
                            rowsPerPageLabel: 'Registros por página',
                            ofLabel: 'de',
                            allLabel: 'Todo'
                        }"
            :rows="ordenesTrabajo"
            :search-options="{
                        enabled: true,
                        placeholder: 'Buscar...'
                    }"
            styleClass="vgt-table"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'detalles'">
                <div class="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>ítem</th>
                        <th>Cantidad</th>
                        <th>Costo</th>
                        <th>Costo total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="detalle in props.row.detalles" :key="detalle.id">
                        <td>{{ detalle.descripcion_item }}</td>
                        <td>{{ decimalFormat(detalle.cantidad) }}</td>
                        <td>{{ moneyFormat(detalle.costo) }}</td>
                        <td>{{ moneyFormat(detalle.costo_total) }}</td>
                      </tr>
                      <tr v-show="props.row.detalles.length === 0">
                        <td colspan="3">
                          <strong>No hay detalles.</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </span>
              <span v-else-if="props.column.field == 'numero_documento'">
                <button
                  @click="verOrdenTrabajo(props.row)"
                  class="btn-info btn--text"
                  type="button"
                >{{ props.row.tipo_documento + props.row.numero_documento }}</button>
              </span>
              <span v-else-if="props.column.field == 'numero_proforma'">
                <button
                  @click="verProforma(props.row)"
                  class="btn-info btn--text"
                  type="button"
                >{{ props.row.numero_proforma }}</button>
              </span>
              <span
                v-else-if="props.column.field == 'costo_total'"
              >{{ moneyFormat(props.row.costo_total) }}</span>
              <span v-else>{{ props.formattedRow[props.column.field] }}</span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    rowStyleClassFn: function(row) {
      switch (row.estado) {
        case "E":
          return "tr--canceled";
        case "A":
          return "tr--issued";
        case "F":
          return "tr--authorized";
        case "V":
          return "tr--pending";
      }
      return "";
    },
    inputPersona: function() {
      if (this.selectedPersona !== null)
        this.form.persona_id = this.selectedPersona.id;
      else this.form.persona_id = "";
    },
    inputVendedor: function() {
      if (this.selectedVendedor !== null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else this.form.vendedor_id = "";
    },
    verProforma: function(ot) {
      window.open(
        url + "/comprobantes?id_comprobante=" + ot.proforma_id,
        "_blank"
      );
    },
    verOrdenTrabajo: function(ot) {
      let urlApi = url + "/orden-trabajo/" + ot.id + "/edit";
      window.open(urlApi, "_blank");
    },
    exportarExcel: function() {
      this.form.exportar = "E";
      let urlApi = url + "/reporte-ordenes-trabajo" + this.serialize(this.form);
      window.open(urlApi, "_blank");
    },
    exportarPDF: function() {
      this.form.exportar = "P";
      let urlApi = url + "/reporte-ordenes-trabajo" + this.serialize(this.form);
      window.open(urlApi, "_blank");
    },
    serialize: function(obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function(a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    changePersonalizado: function() {
      let hasta = new Date();
      let desde = new Date();
      desde.setDate(desde.getDate() - 30);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
      this.form.hasta = moment(hasta).format("YYYY-MM-DD");
      this.consultar();
    },
    cargarDatos: function() {
      let that = this;
      axios.get(url + "/datos-orden-trabajo").then(function(response) {
        that.personas = response.data.personas;
        that.vendedores = response.data.vendedores;
      });
    },
    consultar: function() {
      this.form.exportar = "N";
      let that = this;
      axios
        .get(url + "/reporte-ordenes-trabajo", {
          params: this.form
        })
        .then(function(response) {
          that.ordenesTrabajo = response.data;
        });
    }
  },
  mounted: function() {
    this.cargarDatos();
  },
  data: function() {
    return {
      moneyFormat: moneyFormat,
      decimalFormat: decimalFormat,
      form: {
        sin_personas: false,
        desde: "",
        hasta: "",
        tipo_fecha: "H",
        con_proforma: "A",
        numero_proforma: "",
        estado: "T",
        numero_orden_trabajo: "",
        exportar: "N",
        conDetalle: false,
        vendedor_id: "",
        persona_id: ""
      },
      personas: [],
      vendedores: [],
      selectedPersona: null,
      selectedVendedor: null,
      ordenesTrabajo: []
    };
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ordenes-trabajo/ReporteOrdenesTrabajo.vue